import ReportDom from "../../../../../components/common/ReportDom";
import ServiceVoucherBody from "./ServiceVoucherBody";

export default function ServicePrint({ id }) {
  return (
    <ReportDom
      renderTable={() => <ServiceVoucherBody service_id={id} printMode />}
    />
  );
}
